import { LoginDetails } from './login-details.model';

export class LoginVerification extends LoginDetails {
	public Otp: string;
	public LgCode: string;
	public LcCode: string;
	public SourceCode: string;
	public MobileRelationshipId: number;

	public UtmSource: string;
	public UtmTerm: string;
	public UtmMedium: string;
	public UtmCampaign: string;
	public UtmContent: string;
	public UtmPromo: string;
	public UtmDeviceId: string;
	public UtmAppid: string;
	public UtmAdvertisementId: string;
	public UtmAppsflyerid: string;
	public UtmOSversion: string;
	public UtmATTConsent: string;
	
}
